/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoringDeviceType,
    ReadOnlyMonitoringDeviceTypeFromJSON,
    ReadOnlyMonitoringDeviceTypeFromJSONTyped,
    ReadOnlyMonitoringDeviceTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20033
 */
export interface InlineResponse20033 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20033
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20033
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20033
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoringDeviceType>}
     * @memberof InlineResponse20033
     */
    results: Array<ReadOnlyMonitoringDeviceType>;
}

export function InlineResponse20033FromJSON(json: any): InlineResponse20033 {
    return InlineResponse20033FromJSONTyped(json, false);
}

export function InlineResponse20033FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20033 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoringDeviceTypeFromJSON)),
    };
}

export function InlineResponse20033ToJSON(value?: InlineResponse20033 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoringDeviceTypeToJSON)),
    };
}


